;(function () {
  'use strict'
  angular.module('obex').factory('conversationService', [
    '$rootScope',
    '$http',
    'authService',
    'obexConstant',
    ($rootScope, $http, authService, obexConstant) => {
      return {
        getConversation(fromNumber) {
          var loginMember = authService.getLoginMember()
          const url = `${
            obexConstant.urlGetConversation
          }/fromNumber/${fromNumber.replace('+', '')}/travelagentid/${
            loginMember.Id
          }`
          return authService.getAuthorizationHeader().then((authHeader) => {
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        updateConversation(fromNumber, smsStatus) {
          var loginMember = authService.getLoginMember()
          console.log(
            'call authService.getLoginMember() in alert.service ',
            loginMember,
          )
          return $http.get(
            '/conversation/' +
              fromNumber +
              '/' +
              loginMember.Id +
              '/' +
              smsStatus,
          )
        },
        sendAttachment(imgOrPdf, chatParam) {
          var fd = new FormData()
          fd.append('image', imgOrPdf)
          fd.append('socketId', chatParam.socketId)
          fd.append('agentId', chatParam.agentId)
          fd.append('agentFirstName', chatParam.agentFirstName)
          fd.append('agentLastName', chatParam.agentLastName)
          fd.append('agentEmail', chatParam.agentEmail)
          fd.append('agentOrganizationId', chatParam.agentOrganizationId)
          fd.append('agencyName', chatParam.agencyName)
          fd.append('smstext', chatParam.smstext)
          fd.append('topic', chatParam.topic)
          fd.append('travelerId', chatParam.travelerId)
          fd.append('travelerNumber', chatParam.travelerNumber)
          fd.append('travelerFirstName', chatParam.travelerFirstName)
          fd.append('travelerLastName', chatParam.travelerLastName)
          fd.append('channel', chatParam.channel)

          return $http.post('/smsImgOrPdf', fd, {
            headers: { 'Content-Type': undefined },
            transformRequest: angular.identity,
          })
        },
        getTopic(email) {
          const url = `${obexConstant.urlGetTopic}/${email}`
          return authService.getAuthorizationHeader().then((authHeader) => {
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        updateSocketId(data) {
          const url = `${obexConstant.urlGetConversation}/socketid/${data.socketId}/travelagentemail/${data.email}`
          return authService.getAuthorizationHeader().then((authHeader) => {
            return $http.put(url, data, {
              headers: authHeader,
            })
          })
        },
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./client/js/services/conversation.service.js